import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ApiGetSuccessResponse } from '../models/common/api-get-success-response';
import { Rate } from '../models/entities/rate';

@Injectable({
  providedIn: 'root',
})
export class RatesService {
  constructor(private apiService: ApiService) {}

  findAll(vendorId: number): Observable<ApiGetSuccessResponse<Rate[]>> {
    return this.apiService.get('rates/' + vendorId);
  }

  store(rateRequest): Promise<Rate> {
    return this.apiService.post('rates', rateRequest);
  }

  toggleActive(id: number, active: boolean): Promise<Rate> {
    return this.apiService.put(`rates/${id}/active`, { active });
  }

  update(rate: Rate, rateRequest): Promise<Rate> {
    return this.apiService.put('rates/' + rate.id, rateRequest);
  }

  delete(id: number): Promise<void> {
    return this.apiService.delete('rates/' + id);
  }
}
